import React from "react";
import "./AdminBanksTable.css"

export default function AdminBankTable({ onDelete, BanksData, onEdit }) {
 
//    const styles = `
//     .bank-grid {
//       display: grid;
//       grid-template-columns: repeat(4, 1fr);
//       gap: 20px;
//       width:100%;      
//     }
  
//     .bank-card {
//       position: relative;
//       border: 1px solid #ccc;
//       border-radius: 8px;
//       overflow: hidden;
//       height: 400px; 
//     }
  
//     .bank-container {
//       position: relative;
//       overflow: hidden;
//       height: 100%; 
//     }
  
//     .bank-image {
//       width: 100%;
//       height: 400px;
//       object-fit: cover;
//     }
  
//     .edit-button, .delete-button {
//       position: absolute;
//       padding: 5px 10px;
//       border: none;
//       border-radius: 5px;
//       cursor: pointer;
//       z-index: 1;
//     }
  
//     .edit-button {
//       top: 10px;
//       right: 10px;
//       background-color: blue;
//       color: white;
//     }
  
//     .delete-button {
//       top: 10px;
//       left: 10px;
//       background-color: red;
//       color: white;
//     }
  
//     .data-overlay {
//       position: absolute;
//       bottom: 10px;
//       left: 50%;
//       transform: translateX(-50%);
//       color: white;
//       text-align: center;
//       text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
//       background-color: rgba(0, 0, 0, 0.5);
//       padding: 10px;
//       width: calc(100% - 20px); 
//       box-sizing: border-box; 
//     }
  
//     @media (max-width: 1200px) {
//       .bank-grid {
//         grid-template-columns: repeat(4, 1fr);
//         .bank-card{
//         width:300 px;
//         }
//       }
//     }
  
//     @media (max-width: 900px) {
//       .bank-grid {
//         grid-template-columns: repeat(3, 1fr);
//       }
//     }
  
//     @media (max-width: 600px) {
//       .bank-grid {
//         grid-template-columns: repeat(2, 1fr);
//       }
//     }
    
//     @media (max-width: 400px) {
//       .bank-grid {
//         grid-template-columns: repeat(1, 1fr);
//       }
//     }

// `;

//   const styleSheet = document.createElement("style");
//   styleSheet.type = "text/css";
//   styleSheet.innerText = styles;
//   document.head.appendChild(styleSheet);
  return (
    <div className=" ">
      <div>
        {BanksData.length > 0 ?
        <div className="bank-grid  mt-6 mb-6">
          {BanksData.map((bank) => (
            <div key={bank.id} className="bank-card space-x-2">
              <div className="bank-container">
                <img src={bank.image_url} alt={bank.name} className="bank-image" 
                // style={{ objectFit: "cover", width: "100%", height: "100%" }}
                // onError={(e) => e.target.style.display = 'none'}
                />
                <div className="data-overlay">
                  <p className="text-white italic ">{bank.name}</p>
                  <p className="text-white italic ">{bank.email}</p>
                  <h4 className="text-white italic ">{bank.hq_location}</h4>
                  <p className="text-white italic ">{bank.paybill}</p>
                </div>
                <button className="edit-button bg-blue-500 " onClick={() => onEdit(bank)}>EDIT</button>
                <button className="delete-button" onClick={() => onDelete(bank)}>DELETE</button>
              </div>
            </div>
          ))}
        </div>
        : <p>Sorry, there are no banks </p>}
        </div>
      
    </div>
  );
}

